
import store from '@/store'

import wsCmd from '@/plugins/wsCmd'
import {toWebsocketData} from '@/utils/websocketutils'



//获取账号列表
export function getFriendCommentList(data) {
    let _data = toWebsocketData(wsCmd.cmd_37,data)
    return store.dispatch('websocket/sendObj',_data)
}
//回复评论消息
export function replyComment(data) {
    let _data = toWebsocketData(wsCmd.cmd_36,data)
    return store.dispatch('websocket/sendObj',_data)
}